import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { ISCUser } from "../../common/salescredit/salescredit-role-types";
import colors from "../../common/utils/colors";
import { Format } from "../../common/utils/format";
import { ISalesCreditTopTeams } from "./types";

const pd = new SCProfileDictionary();
export function MapData(rawdata: IGenericAggregateResponse, userRole: ISCUser) {
  const mappedTopSales: ISalesCreditTopTeams = {
    ValidData: true,
    Y1: 0,
    Y2: 0,
    budget: [],
    teams: [],
    ytdResults: [],
    ytd_1Results: [],
  };
  mappedTopSales.Y1 = Format.GetYear(
    rawdata.request ? rawdata.request.date : ""
  );
  mappedTopSales.Y2 = mappedTopSales.Y1 - 1;
  let rowCount = 0;
  let totalYtd = 0;
  let totalYtd1 = 0;

  for (const row of rawdata.aggregates ? rawdata.aggregates : []) {
    const team = row.dimensionAttributeValues[SCAttributes.SC_SALESBEN_TEAM];
    mappedTopSales.teams.push(team);
    const ytd =
      row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_YTD)];
    const ytd1 =
      row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_YTD_1)];
    const yoyper =
      row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_YOY_PER)];

    if (!isNaN(ytd)) {
      totalYtd += ytd;
    }
    if (!isNaN(ytd1)) {
      totalYtd1 += ytd1;
    }

    mappedTopSales.ytdResults.push({
      desc: "(" + Format.FormatYoY(yoyper, true, true) + " YoY)",
      x: rowCount,
      y: Format.FormatNumber(ytd, 1000, 2),
    });

    mappedTopSales.ytd_1Results.push(Format.FormatNumber(ytd1, 1000, 2));
    rowCount++;
    if (rowCount === 10) {
      break;
    }
  }
  if (totalYtd === 0 && totalYtd1 === 0) {
    mappedTopSales.ValidData = false;
    return mappedTopSales;
  }
  return mappedTopSales;
}

export function GetTeamFilter(data: IGenericAggregateResponse): string {
  if (data.aggregates === undefined) {
    return "";
  }
  let teamFilter = "";
  for (const item of data.aggregates) {
    teamFilter +=
      item.dimensionAttributeValues[SCAttributes.SC_SALESBEN_TEAM] + "+";
  }
  return `salesben_team:${
    teamFilter.length > 0 ? teamFilter.substr(0, teamFilter.length - 1) : ""
  }`;
}

export function BuildChartOptions(
  data: ISalesCreditTopTeams,
  useBudget = false
) {
  return {
    chart: {
      type: "bar",
    },
    colors,
    credits: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        grouping: false,
        shadow: false,
      },
    },
    series: useBudget
      ? GetSeriesWithBudget(data)
      : GetSeriesWithOutBudget(data),
    title: {
      text: "",
    },
    tooltip: {
      crosshairs: true,
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y:,.0f} K€</b> {point.desc}<br/>',
      shared: true,
    },
    xAxis: {
      categories: data.teams,
      crosshair: true,
      labels: {
        format: "<b>{value}<b>",
      },
    },
    yAxis: {
      title: {
        text: "Sales Credit (K€)",
      },
    },
  };
}

function GetSeriesWithBudget(data: ISalesCreditTopTeams) {
  return [
    {
      color: "#444852",
      data: data.ytdResults,
      name: data.Y1,
      pointPadding: 0.4,
      states: {
        hover: {
          enabled: false,
        },
      },
      type: "column",
      zIndex: 1,
    },
    {
      color: "#b4bbcb",
      data: data.ytd_1Results,
      name: data.Y2,
      pointPadding: 0.2,
      states: {
        hover: {
          enabled: false,
        },
      },
      type: "column",
      zIndex: 0,
    },
    {
      color: "#dc4941",
      data: data.budget,
      lineWidth: 0,
      name: data.Y1 + " Budget",
      states: {
        hover: {
          enabled: false,
        },
      },
      type: "spline",
      zIndex: 2,
    },
  ];
}

function GetSeriesWithOutBudget(data: ISalesCreditTopTeams) {
  return [
    {
      color: "#444852",
      data: data.ytdResults,
      name: data.Y1,
      pointPadding: 0.4,
      states: {
        hover: {
          enabled: false,
        },
      },
      type: "column",
      zIndex: 1,
    },
    {
      color: "#b4bbcb",
      data: data.ytd_1Results,
      name: data.Y2,
      pointPadding: 0.2,
      states: {
        hover: {
          enabled: false,
        },
      },
      type: "column",
      zIndex: 0,
    },
  ];
}

function GetBudget(
  budgetdata: IGenericAggregateResponse,
  team: string
): number {
  const budgetRow =
    budgetdata && budgetdata.aggregates && budgetdata.aggregates.length > 0
      ? budgetdata.aggregates.filter(
          rowBudget =>
            rowBudget.dimensionAttributeValues[
              SCAttributes.SC_SALESBEN_TEAM
            ] === team
        )
      : null;
  return budgetRow && budgetRow.length > 0
    ? budgetRow[0].indicatorKpiValues[SCKpis.SC_BUDGET_Team]
    : 0;
}
